module.exports = __webpack_public_path__ + "static/media/product_detail_03.d66c03e4.jpg";